import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { CheckboxControl } from '../../../models/controls/checkbox-control';
import { Subscription } from 'rxjs';
import { AccountInformationComponent } from '../account-information/account-information.component';

@Component({
  selector: 'app-acceptation-form',
  templateUrl: './acceptation-form.component.html',
  styleUrls: ['./acceptation-form.component.scss'],
})
export class AcceptationFormComponent
  implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('formElement')
  form?: NgForm;

  @Input()
  language: string | undefined;

  @Output()
  readonly isReady = new EventEmitter<boolean>();

  @ViewChild(AccountInformationComponent)
  accountInformation?: AccountInformationComponent;

  readonly terms = new CheckboxControl('terms', 'termsText');

  readonly signCertified = new CheckboxControl('sign', 'signatureText');

  private formStatusChange?: Subscription;

  ngOnInit(): void {
    this.terms.required = true;
    this.signCertified.required = true;
  }

  ngAfterViewInit(): void {
    this.formStatusChange = this.form?.statusChanges?.subscribe(() =>
      this.isReady.emit(this.form?.valid || false)
    );
  }

  ngOnDestroy(): void {
    this.formStatusChange?.unsubscribe();
  }
}
